module.exports=function(scope){ return `{
    "data": {
        "glasses": false,
        "sessionTokenStatus": 0,
        "faceMapType": 0,
        "livenessStatus": 0,
        "auditTrailVerificationCheck": 0,
        "isLowQuality": false,
        "results": [
            {
                "auditTrailImage": "..."
                "matchLevel": 10,
                "enrollmentIdentifier": "foo"
            },
            {
                "auditTrailImage": "..."
                "matchLevel": 10,
                "enrollmentIdentifier": "bar"
            }
        ],
        "auditTrailMatchCheck": 0,
        "isReplayFaceMap": true
    },
    "meta": {
        "code": 200,
        "message": "The search request was processed successfully.",
        "ok": true,
        "m": {
            "searchTimeInMS": ...,
            "prepareAndUpdateTimeInMS": ...,
            "totalDurationInMS": ...
        }
    }
}`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/response/success/search.json.tpl